import { ButtonLink } from '../components/ui/Button';

export default function NotFound() {
  return (
    <section className="section-shell">
      <div className="mx-auto max-w-xl py-20 text-center">
        <p className="text-6xl font-extrabold text-brand-200">404</p>
        <h1 className="mt-4 text-3xl">We cannot find that page</h1>
        <p className="mt-4 text-base text-brand-900/60">
          The link may be out of date, or the page moved.
        </p>
        <ButtonLink to="/" variant="primary" size="lg" className="mt-8">
          Back to home
        </ButtonLink>
      </div>
    </section>
  );
}
